import { useMemo } from "react";
import { Button, SelectButton, Icon } from "@wbly/ui";
import { iconsaxSetting4 } from "@wbly/tokens/icon";
import { useStore } from "@nanostores/react";
import { triggerDrawer } from "../../../stores/ui.store";
import {
  $resultsCount,
  $filters,
  $sortOptions,
  $selectedSort,
} from "../../../pages/[locale]/personalized-books/stores/filters.store";
import { trackSortBy } from "./track-sort-by";
import styles from "./ActionBar.module.css";

const { button, actionBar, bookCount, counter, filterIcon } = styles;

export const ActionBar = ({
  filterTitleTranslation,
  filterResultsTranslation,
  filters,
}) => {
  const totalBooksCount = useStore($resultsCount);
  const filterStore = useStore($filters);
  const hasActiveFilters = filterStore && Object.keys(filterStore).length > 0;
  const sortOptions = useStore($sortOptions);
  const selectedSort = useStore($selectedSort);

  let filtersCount = 0;
  if (hasActiveFilters) {
    filtersCount = Object.keys(filterStore).reduce(
      (acc, key) => acc + filterStore[key].length,
      0
    );
  }

  const hasSortOptions = useMemo(
    () => sortOptions && sortOptions.length > 0,
    [sortOptions]
  );

  const selectedSortLabel = sortOptions.find(
    (option) => option.id === selectedSort
  )?.label;

  return (
    <div className={actionBar} data-opt-testid="filterBar">
      <p className={bookCount}>
        {totalBooksCount} {filterResultsTranslation}
      </p>
      {hasSortOptions && (
        <SelectButton
          outline
          id="sort-by"
          value={selectedSort}
          onChange={() => trackSortBy(selectedSortLabel)}
          options={sortOptions}
        />
      )}
      {filters && (
        <Button
          type="button"
          outline
          className={button}
          onClick={() => triggerDrawer()}
          data-testid="filters-trigger-button"
        >
          {filterTitleTranslation}{" "}
          {hasActiveFilters && <em className={counter}>{filtersCount}</em>}
          <Icon href={iconsaxSetting4} className={filterIcon} />
        </Button>
      )}
    </div>
  );
};
